/**
 * @file projectContest
 *
 * @module projectContest
 *
 */

import $ from 'jquery';

(function($, Drupal) {
  'use strict';

  var config = {
    groupInputFile : '.input-file',
    formManagedFile : '.form-managed-file',
    uploadBtn : '.js-upload-button',
    removeBtn : '[id*="remove-button"]',
    formProjectContest : '.fpi-form-project-contest',
    formItem : '.fpi-form-item',
  };

  Drupal.behaviors.uploadFileButton = {
    attach: function (context) {
      let $context = $(context);
      if(!$context.is(config.formProjectContest)) {

        let $formItems = $context.find(config.formItem);

        // Hide the uploadBtn when needed.
        for(let i=0; i<$formItems.length; i++) {
          if($formItems[i].querySelector(config.removeBtn) && $formItems[i].querySelector(config.uploadBtn)) {
            $formItems[i].querySelector(config.uploadBtn).style.display = 'none';
          }
        }

      }

    },
  };

  let noticeContact = "<strong>IMPORTANT</strong> : Les emails de confirmation de dépôt de dossiers et de relance de dossiers incomplets comprenant le lien pour retourner sur le formulaire seront envoyés à cette adresse.";
  if ($("#edit-group-project-owner-group-prj-wk-mn-con")) {
    $("#edit-group-project-owner-group-prj-wk-mn-con legend").after("<div class='fieldset-wrapper'>" + noticeContact + "</div>");
  }

  let noticeContact2 = "<strong>IMPORTANT</strong> : Un dossier dans lequel un des co-promoteurs n’est pas adhérent de la FPI est irrecevable.";
  if ($("#edit-group-project-owner-group-prj-wk-2")) {
    $("#edit-group-project-owner-group-prj-wk-2 > legend").after("<div class='fieldset-wrapper'>" + noticeContact2 + "</div>");
  }

  // Hide some project categories.
  if ($("#edit-field-ref-contest-categories")) {
    // For preprod.
    $("#edit-field-ref-contest-categories option[value=721]").hide();
    $("#edit-field-ref-contest-categories option[value=730]").hide();
    $("#edit-field-ref-contest-categories option[value=733]").hide();
    $("#edit-field-ref-contest-categories option[value=731]").hide();

    // For prod.
    $("#edit-field-ref-contest-categories option[value=881]").hide();
    $("#edit-field-ref-contest-categories option[value=745]").hide();
    $("#edit-field-ref-contest-categories option[value=739]").hide();
    $("#edit-field-ref-contest-categories option[value=803]").hide();
    $("#edit-field-ref-contest-categories option[value=742]").hide();
    $("#edit-field-ref-contest-categories option[value=977]").hide();
    $("#edit-field-ref-contest-categories option[value=744]").hide();
    $("#edit-field-ref-contest-categories option[value=1063]").hide();
  }

  var formContest = $("#project-contest-step-form");
  var submitContest = $("#edit-submit");

  window.dataLayer = window.dataLayer || [];
  if (formContest && submitContest.val() === 'Terminer') {
    submitContest.click(function() {
      window.dataLayer.push({
        'event': 'formSubmission',
        'formType': 'contestForm',
      });
    });
  }

})($, Drupal);



// WEBPACK FOOTER //
// ./src/js/projectContest.js